<style lang="less">
    .libtitle-context {
        min-width: 166px;
    }
</style>
<i18n>
{
  "zh": {
    "unShow": "不显示",
    "collapseAll": "收起所有",
    "expandAll": "展开所有",
    "addSymbol": "导入符号",
    "renameLib": "重命名",
    "saveLib": "导出",
    "del": "删除",
    "delSucc": "删除成功",
    "delFail": "删除失败",
    "movUp": "上移",
    "movDown": "下移",
    "editSymbol": "编辑符号库",
    "selectAll": "全选符号",
    "publishSymbol": "发布符号库"
  },
  "en": {
    "unShow": "UnShow",
    "collapseAll": "Collapse all",
    "expandAll": "Expand all",
    "addSymbol": "Import symbol",
    "renameLib": "Rename",
    "saveLib": "Export",
    "del": "Delete",
    "delSucc": "Delete Success",
    "delFail": "Delete Failed",
    "movUp": "Move Up",
    "movDown": "Move Down",
    "editSymbol": "Edit symbol",
    "selectAll": "Select all symbols",
    "publishSymbol": "Publish"
  },
  "fr": {
    "addSymbol": "Importer des symboles",
    "renameLib": "Renommer",
    "saveLib": "Exporter",
    "del": "Supprimer",
    "delSucc": "Supprimé avec succès",
    "delFail": "Échec de suppression",
    "movUp": "déplacer vers haut",
    "movDown": "Descendre",
    "editSymbol": "Modifier la bibliothèque de symboles",
    "selectAll": "Sélectionner tous les symboles"
  },
  "de": {
    "addSymbol": "Symbole importieren",
    "renameLib": "Umbenennen",
    "saveLib": "Exportieren",
    "del": "Löschen",
    "delSucc": "Löschen erfolgreich",
    "delFail": "Löschen gescheitert",
    "movUp": "Nach oben verschieben ",
    "movDown": "Nach unten verschieben ",
    "editSymbol": "Symbolbibliothek bearbeiten",
    "selectAll": "Alle Symbole auswählen"
  },
  "jp": {
    "addSymbol": "形状のインポート",
    "renameLib": "名前の変更",
    "saveLib": "エクスポート",
    "del": "削除",
    "delSucc": "削除に成功しました",
    "delFail": "削除に失敗しました",
    "movUp": "上に移動",
    "movDown": "下に移動",
    "editSymbol": "形状を編集",
    "selectAll": "すべての記号を選択"
  },
  "es": {
    "addSymbol": "Agregar símbolo",
    "renameLib": "Renombrar",
    "saveLib": "Exportar",
    "del": "Eliminar",
    "delSucc": "Borrado exitoso",
    "delFail": "Borrado fallido",
    "movUp": "Mover hacia arriba",
    "movDown": "Mover hacia abajo",
    "editSymbol": "Editar biblioteca de símbolos",
    "selectAll": "Seleccionar todos los símbolos"
  },
  "pt": {
    "addSymbol": "Importar Símbolo",
    "renameLib": "Renomear",
    "saveLib": "Exportar",
    "del": "Eliminar",
    "delSucc": "Eliminado com Sucesso",
    "delFail": "Falha ao Eiminar",
    "movUp": "Mover para cima",
    "movDown": "Mover para baixo",
    "selectAll": "Selecione todos os símbolos"
  },
  "it": {
    "addSymbol": "Importa simboli",
    "renameLib": "Rinomina",
    "saveLib": "Esporta",
    "del": "Elimina",
    "delSucc": "Eliminazione avvenuta con successo",
    "delFail": "Eliminazione fallita",
    "movUp": "Andare avanti",
    "movDown": "Abbassare",
    "selectAll": "Seleziona tutto il simbolos"
  },
  "tw": {
    "addSymbol": "導入符號",
    "renameLib": "重命名",
    "saveLib": "導出",
    "del": "刪除",
    "delSucc": "刪除成功",
    "delFail": "刪除失敗",
    "movUp": "上移",
    "movDown": "下移",
    "editSymbol": "編輯符號庫",
    "selectAll": "全选符号"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" :showTippy="false" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import appConfig from "@/public/globalConfig";
    import { InternalLimitTableIds, OverseaLimitTableIds } from "@/app/utils/constant";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class pageBarContext extends Vue {
        @Prop() readonly close!: any;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        showImportModal: boolean = false;
        importDB: string = "";
        importTB: string = "";
        importID: number = 0;

        get libraryType() {
            return this.$store.state.library.libraryType;
        }

        get menuList() {
            let list = [
                { key: "addSymbol", isRender: this.isCustomLib },
                {
                    key: "renameLib",
                    isRender: this.isCustomLib && this.collectTBID != this.dbAndTable[2],
                },
                {
                    key: "del",
                    isRender: this.isCustomLib && this.collectTBID != this.dbAndTable[2],
                },
                {
                    key: "saveLib",
                    showVip: !this.vip && ~this.limitTableIds.indexOf(this.dbAndTable[2]),
                },
                { key: "movUp", disabled: this.selectLibraryTitlePos[0] == 0 },
                {
                    key: "movDown",
                    disabled: this.selectLibraryTitlePos[0] == this.selectLibraryTitlePos[1],
                },
                { key: "cleanAll" },
                { key: "editSymbol", isRender: this.isCustomLib },
                { key: "selectAll", disabled: this.isNullLibrary },
                { key: "publishSymbol", isRender: this.canPublish, disabled: this.isNullLibrary },
            ];
            let newList = [];

            if (this.libraryType === "publicLibrary") {
                newList = [
                    { key: "unShow", label: "" },
                    { divide: true },
                    {
                        key: "saveLib",
                        showVip: !this.vip && ~this.limitTableIds.indexOf(this.dbAndTable[2]),
                        label: "",
                    },
                    { key: "selectAll", disabled: this.isNullLibrary, label: "" },
                    { divide: true },
                    { key: "movUp", disabled: this.selectLibraryTitlePos[0] == 0, label: "" },
                    {
                        key: "movDown",
                        disabled: this.selectLibraryTitlePos[0] == this.selectLibraryTitlePos[1],
                        label: "",
                    },
                    { divide: true },
                    { key: "collapseAll", label: "" },
                    { key: "expandAll", label: "" },
                ];
            } else if (this.libraryType === "myLibrary") {
                newList = [
                    {
                        key: "renameLib",
                        isRender: this.isCustomLib && this.collectTBID != this.dbAndTable[2],
                        label: "",
                    },
                    { key: "editSymbol", isRender: this.isCustomLib, label: "" },
                    { key: "addSymbol", isRender: this.isCustomLib, label: "" },
                    { divide: true },
                    {
                        key: "saveLib",
                        showVip: !this.vip && ~this.limitTableIds.indexOf(this.dbAndTable[2]),
                        label: "",
                    },
                    { divide: true },
                    {
                        key: "del",
                        isRender: this.isCustomLib && this.collectTBID != this.dbAndTable[2],
                        label: "",
                    },
                ];
            }

            newList = newList.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true));
            let last = newList[newList.length - 1];
            if (last.divide) {
                newList.pop();
            }
            newList.forEach((item) => {
                if ("label" in item) {
                    item.label = this.$t(item.key) as string;
                }
            });
            return { container: "libtitle-context", list: newList };
        }

        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "unShow",
                    () => {
                        event.stopPropagation();
                        this.submitAction("unShow");
                    },
                ],
                [
                    "addSymbol",
                    () => {
                        event.stopPropagation();
                        this.openImport();
                    },
                ],
                [
                    "renameLib",
                    () => {
                        event.stopPropagation();
                        this.renameTable();
                    },
                ],
                [
                    "del",
                    () => {
                        event.stopPropagation();
                        this.deleteLibrary();
                    },
                ],
                [
                    "saveLib",
                    () => {
                        event.stopPropagation();
                        this.saveLibrary();
                    },
                ],
                [
                    "movUp",
                    () => {
                        event.stopPropagation();
                        this.submitAction("up");
                    },
                ],
                [
                    "movDown",
                    () => {
                        event.stopPropagation();
                        this.submitAction("down");
                    },
                ],
                [
                    "cleanAll",
                    () => {
                        event.stopPropagation();
                        this.submitAction("delete");
                    },
                ],
                [
                    "editSymbol",
                    () => {
                        event.stopPropagation();
                        this.editSelfLibrary();
                    },
                ],
                [
                    "selectAll",
                    () => {
                        this.selectAllSymbol();
                    },
                ],
                [
                    "publishSymbol",
                    () => {
                        this.publishLibrary();
                    },
                ],
                [
                    "collapseAll",
                    () => {
                        event.stopPropagation();
                        this.submitAction("collapseAll");
                    },
                ],
                [
                    "expandAll",
                    () => {
                        event.stopPropagation();
                        this.submitAction("expandAll");
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }

        openImport() {
            this.closeMenu();
            console.log(11);
            this.$store.commit("setLibraryState", {
                type: "showImportModal",
                data: true,
            });
        }

        uploadStoreInfo() {
            // del table
            let menu = this.$store.state.library.menuList;
            let checkbox = JSON.parse(JSON.stringify(this.$store.state.library.checkbox));
            let showList = this.$store.state.library.displayList;

            let DbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];

            let arr = checkbox[DbName];
            for (let i = 0; i < arr.length; i++) {
                // 移除checkbox选中框
                if (arr[i] == tableID) {
                    arr.splice(i, 1);
                    break;
                }
            }
            this.$store.state.library.checkbox = checkbox;

            for (let i = 0; i < menu.length; i++) {
                // 更新用户自定义库的表名
                if (menu[i].groupName == DbName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].id == tableID) {
                            menu[i].children.splice(j, 1);
                        }
                    }
                }
            }

            for (let i = 0; i < showList.length; i++) {
                // 删除预览缓存
                if (showList[i].groupName == DbName) {
                    let children = showList[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == tableName) {
                            children.splice(j, 1);
                            break;
                        }
                    }
                }
            }
            let ts: any = this;
            ts.$bus.$asyncEmit("uploadToCloud", {
                message: {
                    type: "deleteLib",
                    isUserDB: true,
                    data: {
                        tableID,
                    },
                },
            });
        }
        closeMenu() {
            // 关闭右键菜单
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: false,
            });
        }

        editSelfLibrary() {
            this.$bus.$emit("openEditLibriary", this.dbAndTable[2]);
            this.closeMenu();
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        renameTable() {
            this.closeMenu();
            this.showDialog("RenameTable");
            this.sensors.track("libRename", {
                Catalogues: "editFileProcess",
            });
        }
        get limitTableIds() {
            return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
        }
        saveLibrary() {
            this.closeMenu();
            if (!this.vip && ~this.limitTableIds.indexOf(this.dbAndTable[2])) {
                this.$checkAuth({ type: "limitShapeExport", buyTrigger: "exportSymbol" });
                return;
            }
            if (this.dbAndTable[0] && this.dbAndTable[1]) {
                let versionData = {
                    vTableName: `myDBVersion_${this.$store.state.user.userInfo.user_id}`,
                    vTableID: this.dbAndTable[2],
                };
                window["_view"].saveLibToLocal(this.dbAndTable[0], this.dbAndTable[1], versionData);
                this.$track("library", "library title", "saveLibrary");
                this.sensors.track("libExport", {
                    Catalogues: "editFileProcess",
                });
            }
        }
        deleteLibrary() {
            this.closeMenu();
            let ts: any = this;
            let userInfo = this.$store.state.user.userInfo;
            let tempList = this.ossList.slice(0);
            let delSucc = this.$t("delSucc");
            let delFail = this.$t("delFail");
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "deleteTable",
                urls: this.urls,
                data: {
                    DBName: this.dbAndTable[0],
                    tableName: this.dbAndTable[1],
                    tableID: this.dbAndTable[2],
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "deleteTableOK") {
                    this.worker.terminate();
                    this.uploadStoreInfo();
                    let deleteID = -1;
                    let symbol_key = "";

                    for (let i = 0; i < tempList.length; i++) {
                        if (tempList[i].table_id == this.dbAndTable[2]) {
                            deleteID = tempList[i].id;
                            symbol_key = tempList[i].symbol_key;
                            tempList.splice(i, 1);
                            break;
                        }
                    }
                    if (deleteID != -1) {
                        this.$edApi
                            .deleteCustomLibrary({
                                id: userInfo.user_id,
                                token: userInfo.token,
                                libs: deleteID,
                                symbol_key,
                            })
                            .then((e) => {
                                this.ossList = tempList;
                                ts.$edMessage.success(delSucc);
                                console.log("delete success ", deleteID, tempList);
                            })
                            .catch((e) => {
                                ts.$edMessage.error(delFail);
                            });
                    }
                }
            };
        }
        selectAllSymbol() {
            this.$bus.$emit("selectAllSymbol", this.dbAndTable[2]);
            this.closeMenu();
        }

        submitAction(type) {
            this.closeMenu();
            this.$bus.$emit("libTitleAction", type);
        }
        async checkVerified() {
            // 检测是否实名
            if (!this.internal) {
                return Promise.resolve(true);
            }
            let userInfo = this.$store.state.user.userInfo;
            const result = await this.$edApi
                .checkShareVerified({
                    id: userInfo.user_id,
                    token: userInfo.token,
                })
                .then((e) => {
                    return e.data;
                });
            return result;
        }
        publishLibrary() {
            this.closeMenu();
            this.checkVerified().then((isBind) => {
                if (!isBind) {
                    this.$store.commit("toShowPhoneDialog", { fromBtn: "publishLibraryBtn" });
                } else {
                    this.$bus.$emit("publishLibrary", this.dbAndTable[2]);
                }
            });
            this.$bus.$emit("publishLibrary", this.dbAndTable[2]);
        }
        get selectLibraryTitlePos() {
            return this.$store.state.library.selectLibraryTitlePos;
        }
        get ossList() {
            return this.$store.state.library.ossList;
        }
        set ossList(v) {
            this.$store.commit("setLibraryState", {
                type: "ossList",
                data: v,
            });
        }
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }
        get isCustomLib() {
            return this.dbAndTable[2] >= this.collectTBID;
        }
        get canPublish() {
            return this.dbAndTable[2] > this.collectTBID && !this.isPrivate && !this.isTeamsApp;
        }
        get isNullLibrary() {
            return this.$store.state.library.symbolCount == 0;
        }
        mounted() {}
        created() {}
    }
</script>
